import React from 'react';
import Form from '@components/auth/ForgotPassword/components/Form';
import Layout from '@components/auth/layout';

const ForgotPassword = () => (
  <Layout>
    <Form />
  </Layout>
);

export default ForgotPassword;
